import React from "react";
// @ts-ignore
import NavBar from "../../screens/SatCourse/CoursesScreen";
// @ts-ignore
import MockTestBanner from "../../components/SatCourse/MockTestBanner";
// @ts-ignore
import Frame from "../../Assets/Images/Sat-images/Frame.webp";
// @ts-ignore
import QuestionFram from "../../Assets/Images/Sat-images/Vector-img.webp";

export interface MockTestProps {
  isLoading?: boolean;
  isError?: string | boolean;
  Error?: string;
  HandleId: () => void;
}

const MockTest: React.FC<MockTestProps> = (props) => {
  return (
    <>
      {props.isLoading ? (
        <h1>LOADING.........</h1>
      ) : (
        <div className="Home-Container">
          {props.isError ? (
            <h1>{props.Error}</h1>
          ) : (
            <div className="home-sub-container">
              <div>
                <NavBar />
              </div>
              <div className="main-right-container">
                <div>
                  <MockTestBanner title={"Mock Test"} nolesson={"12"} />{" "}
                </div>
                <div className="mock-second-section">
                  <div className="mock-second-left">
                    <div className="second-left-para">
                      <p>
                        The winner of this test will receive a full fee waiver
                        for the College Board SAT test.{" "}
                      </p>
                    </div>
                    <div className="mock-left-list">
                      <ol>
                        <li>
                          Changing the test screen is not allowed. If you try
                          this, your test will end.
                        </li>
                        <li>Your internet connection needs to be stable.</li>
                        <li>
                          Your test is divided into three parts which Include.
                        </li>
                      </ol>
                    </div>
                    <div
                      className="mock-button"
                      onClick={() => {
                        props.HandleId();
                      }}
                    >
                      Let's Go !
                    </div>
                  </div>
                  <div className="mock-line-div"></div>
                  <div className="mock-right-section">
                    <div className="mock-right-list">
                      <div className="mock-reading-div">Reading</div>
                      <div className="mock-right-question-panel">
                        <div className="mock-minutes">
                          <div>
                            <img src={Frame} width="15px" height="15px" alt="Clock" />
                          </div>
                          <div>
                            <p className="mock-haed">32Minutes</p>
                          </div>
                        </div>
                        <div className="mock-question">
                          <img src={QuestionFram} width="15px" height="15px" alt="Question" />
                          <p className="mock-haed">32Questions</p>
                        </div>
                      </div>
                    </div>
                    <div className="mock-right-list">
                      <div className="mock-reading-div">Writting</div>
                      <div className="mock-right-question-panel">
                        <div className="mock-minutes">
                          <div>
                            <img src={Frame} width="15px" height="15px" alt="Clock" />
                          </div>
                          <div>
                            <p className="mock-haed">32Minutes</p>
                          </div>
                        </div>
                        <div className="mock-question">
                          <img src={QuestionFram} width="15px" height="15px" alt="Question" />
                          <p className="mock-haed">32Questions</p>
                        </div>
                      </div>
                    </div>
                    <div className="mock-right-list">
                      <div className="mock-reading-div">Mathematics</div>
                      <div className="mock-right-question-panel">
                        <div className="mock-minutes">
                          <div>
                            <img src={Frame} width="15px" height="15px" alt="Clock" />
                          </div>
                          <div>
                            <p className="mock-haed">32Minutes</p>
                          </div>
                        </div>
                        <div className="mock-question">
                          <img src={QuestionFram} width="15px" height="15px" alt="Question" />
                          <p className="mock-haed">32Questions</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
};
export default React.memo(MockTest);
